const getEnvironment = () => {
  return process.env.NEXT_PUBLIC_APP_ENV || "dev";
};

const configs = {
  dev: {
    NEXT_PUBLIC_API_BASE_URL:
      "https://reflow-connect-api-dev.internal.i-ways-network.org",
    CORE_SERVICE_BASE_URL:
      "https://reflow-connect-core-api-dev.internal.i-ways-network.org",
    WE_AID_SERVICE_BASE_URL:
      "https://weaid-core-management-service-dev.internal.i-ways-network.org",
    MEDIA_MART_BASE_URL: "https://www.mediamarkt.de/de/product",
    EBAY_LISTING_BASE_URL: "https://www.ebay.de/sch/i.html",
    EBAY_LISTED_ITEM_BASE_URL: "https://ebay.de/itm/",
    SAND_BOX_EBAY_BASE_URL: "https://www.ebay.de/itm/",
  },
  stage: {
    NEXT_PUBLIC_API_BASE_URL:
      "https://reflow-connect-api.internal.i-ways-network.org",
    CORE_SERVICE_BASE_URL:
      "https://reflow-connect-core-api.internal.i-ways-network.org",
    WE_AID_SERVICE_BASE_URL:
      "https://weaid-core-management-service-dev.internal.i-ways-network.org",
    MEDIA_MART_BASE_URL: "https://www.mediamarkt.de/de/product",
    EBAY_LISTING_BASE_URL: "https://www.ebay.de/sch/i.html",
    EBAY_LISTED_ITEM_BASE_URL: "https://ebay.de/itm/",
    SAND_BOX_EBAY_BASE_URL: "https://www.ebay.de/itm/",
  },
  live: {
    NEXT_PUBLIC_API_BASE_URL: "https://user-api.reflow-connect.com",
    CORE_SERVICE_BASE_URL: "https://core-api.reflow-connect.com",
    WE_AID_SERVICE_BASE_URL:
      "https://weaid-core-management-service-dev.internal.i-ways-network.org",
    MEDIA_MART_BASE_URL: "https://www.mediamarkt.de/de/product",
    EBAY_LISTING_BASE_URL: "https://www.ebay.de/sch/i.html",
    EBAY_LISTED_ITEM_BASE_URL: "https://ebay.de/itm/",
    SAND_BOX_EBAY_BASE_URL: "https://www.ebay.de/itm/",
  },
};

const environment = getEnvironment();
const variables = configs[environment] || configs.dev;

export default variables;
